export const getEpochTime = (date?: Date) => Math.floor((date ? date.getTime() : Date.now()) / 1000);

const noImageSvg =
  '<svg xmlns="http://www.w3.org/2000/svg" width="240" height="180"><rect width="100%" height="100%" fill="#eeeeee"/>' +
  '<text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#999999" font-family="sans-serif" font-size="16">No image</text></svg>';

/** Shown when a product has no picture, so the storefront never assumes `images[0]` exists. */
export const noImagePlaceholder = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(noImageSvg)}`;

/** URL of the primary (first) product image, or undefined when it has none. */
export const primaryImageUrl = (product?: { images?: { url: string }[] | null } | null): string | undefined =>
  product?.images?.[0]?.url;

export const calculateTotals = ({
  price,
  quantity,
  fixed = 2,
}: {
  price: number;
  quantity: number;
  fixed?: number;
}): number => Number((quantity * price).toFixed(fixed));

export const currencyFormatter = new Intl.NumberFormat('en-NZ', {
  style: 'currency',
  currency: 'NZD',
  minimumFractionDigits: 2, // Minimum number of decimal places
  maximumFractionDigits: 2, // Maximum number of decimal places
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const caseInsensitiveComparator = (valueA: any, valueB: any) => {
  if (valueA === null || valueA === undefined) {
    return -1;
  }
  if (valueB === null || valueB === undefined) {
    return 1;
  }
  return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
};
